const updates = [
  {
    date: '07-31',
    title: '《庆余年2》大结局上线',
    desc: '全集高清完整版已更新，范闲命运终揭晓',
    tag: '新上线',
  },
  {
    date: '07-30',
    title: '《孤舟》第12-14集更新',
    desc: '张颂文曾舜晞谍战大戏持续更新中',
    tag: '更新',
  },
  {
    date: '07-29',
    title: '《唐朝诡事录2》加更两集',
    desc: '杨旭文杨志刚探案组合再破奇案',
    tag: '加更',
  },
  {
    date: '07-28',
    title: '《长相思2》超前点播全集',
    desc: '暑期档仙侠巨制全集已完整上线',
    tag: '全集',
  },
  {
    date: '07-27',
    title: '《玫瑰的故事》4K修复版发布',
    desc: '刘亦菲都市剧经典高清修复画质升级',
    tag: '修复',
  },
  {
    date: '07-26',
    title: '经典专区新增100部港剧',
    desc: 'TVB经典剧集大合集整理上线',
    tag: '上新',
  },
  {
    date: '07-25',
    title: '《繁花》沪语原声版上线',
    desc: '满足剧迷要求的方言原声版本已更新',
    tag: '更新',
  },
  {
    date: '07-24',
    title: '平台播放线路全新升级',
    desc: '新增两条备用CDN线路，观看更稳定',
    tag: '公告',
  },
  {
    date: '07-23',
    title: '《三体》导演剪辑版发布',
    desc: '包含未播出删减片段与幕后花絮',
    tag: '特别版',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-timer-line text-accent-500 text-sm"></i>
            <span className="text-accent-400 text-xs font-medium">实时动态</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新更新动态</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            平台每日资源更新一览，掌握最新追剧资讯
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="flex gap-4 group">
              <div className="flex flex-col items-center flex-shrink-0 w-16">
                <div className="text-foreground-400 text-xs font-medium whitespace-nowrap">{item.date}</div>
                <div className={`w-0.5 flex-1 min-h-[2rem] mt-1 ${
                  i < updates.length - 1 ? 'bg-background-200' : 'bg-transparent'
                }`}></div>
              </div>
              <div className={`flex-1 pb-6 ${i === updates.length - 1 ? '' : ''}`}>
                <div className="bg-background-100 border border-background-200/60 rounded-xl p-4 hover:border-primary-500/20 transition-all cursor-pointer group-hover:bg-background-200/50">
                  <div className="flex items-start justify-between gap-3 mb-1.5">
                    <h4 className="text-foreground-800 font-heading font-bold text-sm">{item.title}</h4>
                    <span className={`px-2 py-0.5 rounded-md text-xs font-semibold flex-shrink-0 ${
                      item.tag === '新上线' || item.tag === '全集' ? 'bg-accent-500/20 text-accent-500' :
                      item.tag === '公告' ? 'bg-secondary-500/20 text-secondary-500' :
                      'bg-primary-500/15 text-primary-500'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-foreground-500 text-xs">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}